<script>
  // Strudel playback + mute/unmute toggle.
  //
  // Via npm, `@strudel/web` exposes evaluate/hush/samples as named ES exports
  // (only initStrudel is put on window), so we destructure them from the import
  // rather than reading window. The library is large and audio can only start
  // inside a user gesture, so we lazily dynamic-import and boot on first click.

  let { code = "" } = $props()

  let playing = $state(false)
  let loading = $state(false)
  let strudel // { evaluate, hush } once booted

  async function ensureStrudel() {
    if (strudel) return strudel
    const { initStrudel, evaluate, hush } = await import("@strudel/web") // lazy: first gesture only
    // No external samples: the hymn uses only built-in synth voices (square/
    // triangle oscillators + white-noise hats). Add a `prebake: () => samples(...)`
    // here if a future pattern needs sample banks like dirt-samples.
    await initStrudel()
    strudel = { evaluate, hush }
    return strudel
  }

  async function toggle() {
    loading = true
    const s = await ensureStrudel() // click = the audio-unlock gesture
    loading = false
    if (playing) {
      s.hush()
      playing = false
    } else {
      s.evaluate(code)
      playing = true
    }
  }
</script>

<button
  type="button"
  aria-label={playing ? "Stop" : "Play"}
  aria-pressed={playing}
  disabled={loading}
  onclick={toggle}
  class="fixed bottom-4 right-4 z-10 grid h-16 w-16 place-items-center rounded-full
         bg-black/30 text-white hover:bg-black/50 disabled:opacity-50"
>
  {#if loading}
    <!-- spinner -->
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
         class="h-10 w-10 animate-spin" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke-opacity="0.25" />
      <path d="M12 3a9 9 0 0 1 9 9" stroke-linecap="round" />
    </svg>
  {:else if playing}
    <!-- stop -->
    <svg viewBox="0 0 24 24" fill="currentColor" class="h-10 w-10" aria-hidden="true">
      <rect x="6" y="6" width="12" height="12" rx="1.5" />
    </svg>
  {:else}
    <!-- play -->
    <svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2.5"
         stroke-linejoin="round" class="h-10 w-10" aria-hidden="true">
      <path d="M8 5v14l11-7z" />
    </svg>
  {/if}
</button>
